/**
 * Snapshot Comparison Store
 *
 * Stores the result of comparing current snapshot with previous snapshot.
 * Used to display NEW and CHANGED badges on profile cards.
 */

import { create } from 'zustand';
import { SnapshotComparison } from '@bedrock-profiles/shared';

interface ComparisonState {
  /** Current snapshot comparison result */
  comparison?: SnapshotComparison;

  /** Whether comparison is currently being computed */
  isComputing: boolean;

  /** Set the comparison result */
  setComparison: (comparison: SnapshotComparison | undefined) => void;

  /** Set computing state */
  setIsComputing: (isComputing: boolean) => void;

  /** Clear comparison */
  clearComparison: () => void;
}

export const useComparisonStore = create<ComparisonState>((set) => ({
  comparison: undefined,
  isComputing: false,

  setComparison: (comparison) => {
    set({ comparison, isComputing: false });
  },

  setIsComputing: (isComputing) => {
    set({ isComputing });
  },

  clearComparison: () => {
    set({ comparison: undefined, isComputing: false });
  },
}));
